import { Link, useLoaderData } from 'react-router';
import { api } from '@/lib/api';
import { fmtDateTime, fmtAgo } from '@/lib/format';
import { RowLink } from '@/components/row-link';
import { CampaignStatus } from './campaign-status';

type Campaign = {
  id: string;
  name: string;
  status: string;
  scheduledAt: string | null;
  completedAt: string | null;
  recipientCount: number;
  stats: { sent?: number; uniqueOpens?: number; uniqueClicks?: number } | null;
  updatedAt: string;
};

export async function campaignsLoader() {
  return api<Campaign[]>('/campaigns');
}

export function CampaignsPage() {
  const campaigns = useLoaderData<typeof campaignsLoader>();
  return (
    <div className="space-y-5">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl">Campaigns</h1>
          <p className="text-sm text-muted-foreground">
            Newsletters: template + segments → test → schedule. Sent in Mailgun batches of 500.
          </p>
        </div>
        <Link
          to="/campaigns/new"
          className="rounded-md bg-[var(--ff-primary)] px-4 py-2 text-sm text-white"
        >
          New campaign
        </Link>
      </div>
      <div className="overflow-x-auto rounded-lg border bg-white">
        <table className="data-table">
          <thead>
            <tr>
              <th>Campaign</th>
              <th>Status</th>
              <th>Recipients</th>
              <th>Sent</th>
              <th>Opens</th>
              <th>Clicks</th>
              <th>Scheduled</th>
              <th>Updated</th>
            </tr>
          </thead>
          <tbody>
            {campaigns.length === 0 && (
              <tr>
                <td colSpan={8} className="py-8 text-center text-muted-foreground">
                  No campaigns yet.
                </td>
              </tr>
            )}
            {campaigns.map((c) => (
              <RowLink key={c.id} href={`/campaigns/${c.id}`}>
                <td>
                  <Link to={`/campaigns/${c.id}`} className="ff-link font-medium">
                    {c.name}
                  </Link>
                </td>
                <td>
                  <CampaignStatus status={c.status} />
                </td>
                <td>{c.recipientCount || '—'}</td>
                <td>{c.stats?.sent ?? '—'}</td>
                <td>{c.stats?.uniqueOpens ?? '—'}</td>
                <td>{c.stats?.uniqueClicks ?? '—'}</td>
                <td className="whitespace-nowrap text-xs">{fmtDateTime(c.scheduledAt)}</td>
                <td className="whitespace-nowrap text-muted-foreground">{fmtAgo(c.updatedAt)}</td>
              </RowLink>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
